import { Icon, Popup } from "semantic-ui-react";

import { DATE_FORMATS_FNS } from "components";
import { isThreeDepartmentEditable } from "utils/appointmentUtils";
import { formatDate } from "utils/dateHelperFunctions";

import type { Appointment } from "models";

type ThreeDepartmentNoteIconProps = {
  appointment: Appointment;
};

type Department = {
  key: string;
  icon: string;
  timestamp: string | null;
};

const DEPARTMENT_CONFIGS = [
  {
    key: "receptionist",
    icon: "user",
    isChecked: (a: Appointment) => a.three_department_receptionist,
    getTimestamp: (a: Appointment) => a.three_department_receptionist_set_at
  },
  {
    key: "parts",
    icon: "gear",
    isChecked: (a: Appointment) => a.three_department_parts,
    getTimestamp: (a: Appointment) => a.three_department_parts_set_at
  },
  {
    key: "workshop",
    icon: "wrench",
    isChecked: (a: Appointment) => a.three_department_workshop,
    getTimestamp: (a: Appointment) => a.three_department_workshop_set_at
  }
];

const getCheckedDepartments = (appointment: Appointment): Department[] =>
  DEPARTMENT_CONFIGS.reduce<Department[]>((acc, { key, icon, isChecked, getTimestamp }) => {
    if (isChecked(appointment)) acc.push({ key, icon, timestamp: getTimestamp(appointment) });
    return acc;
  }, []);

export const ThreeDepartmentNoteIcon = ({ appointment }: ThreeDepartmentNoteIconProps) => {
  if (!isThreeDepartmentEditable(appointment)) return null;

  const checkedDepartments = getCheckedDepartments(appointment);

  if (checkedDepartments.length === 0) return <Icon circular color="red" className="ballot check ThreeDepartmentNoteLabel" />;

  const allChecked = checkedDepartments.length === DEPARTMENT_CONFIGS.length;

  return (
    <Popup
      basic
      wide
      content={
        <div className="ThreeDepartmentNotePopup">
          {checkedDepartments.map(cd => (
            <div key={cd.key} className="ThreeDepartmentNotePopup-row">
              <div>
                <Icon className={cd.icon} />
              </div>
              <div>
                <Icon className="checkmark" color="green" />
              </div>
              <span className="description">{cd.timestamp ? formatDate(cd.timestamp, DATE_FORMATS_FNS.dateMonthYearTime) : ""}</span>
            </div>
          ))}
        </div>
      }
      trigger={<Icon circular color={allChecked ? "green" : "red"} className="ballot check ThreeDepartmentNoteLabel" />}
    />
  );
};
